import React, { CSSProperties, useEffect } from 'react';
import * as yup from 'yup';
import { useFormContext } from './FormContext';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import { useModalContext } from '../../Modules/Modal/Services/ModalContext';

interface FormProps<T = any> {
	children?: React.ReactNode;
	defaultValues?: T;
	schema?: yup.ObjectSchema<any>;
	className?: any;
	style?: CSSProperties | undefined;
	registerForChanges?: boolean;
	onChange?: (data: T) => void;
}
const Form = <T extends object = any>(props: FormProps<T>) => {
	const {
		children,
		defaultValues,
		schema,
		className,
		style,
		registerForChanges = false,
		onChange,
	} = props;
	const modalContext = useModalContext();

	const formMethods = useForm({
		defaultValues: defaultValues || {},
		resolver: schema ? yupResolver(schema) : undefined,
	});

	const { setFormMethods } = useFormContext();

	useEffect(() => {
		formMethods.reset(defaultValues);
	}, [defaultValues]);

	useEffect(() => {
		if (typeof setFormMethods === 'function') {
			setFormMethods(formMethods);
		}
	}, [formMethods]);

	useEffect(() => {
		if (registerForChanges) {
			setTimeout(() => {
				modalContext?.registerForm(() => formMethods);
			}, 500);
		}
		return () => {
			if (registerForChanges) {
				setTimeout(() => {
					modalContext?.unregisterForm(() => formMethods);
				}, 500);
			}
		};
	}, []);

	const values = formMethods.watch();
	useEffect(() => {
		if (onChange) {
			onChange(formMethods.getValues() as T);
		}
	}, [JSON.stringify(values)]);

	return (
		<FormProvider {...formMethods}>
			<form action='' className={className} style={style}>
				{children}
			</form>
		</FormProvider>
	);
};

export default Form;
